
import React from "react";
import { Modal } from "react-bootstrap";

import useTranslation from "../../Hooks/UseTranslation";

import Notification from "../DropdownNotifications/Notification";

import './NotificationsDialog.scss'

interface INotification {

}

export interface INotificationsDialogProps {
  show: boolean;
  title: string;
  notifications: INotification[];
  onHide: () => void;
}

const NotificationsDialog = (props: INotificationsDialogProps) => {

  const { t } = useTranslation()
  const notifications = props.notifications || []
  const unreadCount = notifications.filter((notification: any) => notification.status === 'not_read').length

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      dialogClassName="pl4-notifications-dialog"
      aria-labelledby="pl4-notifications-title"
    >
        <Modal.Header className="pl4-notifications-dialog__header">
          <div className="pl4-notifications-dialog__heading">
            <span className="pl4-notifications-dialog__heading-icon"><i className="far fa-bell" /></span>
            <div>
              <Modal.Title id="pl4-notifications-title">{props.title}</Modal.Title>
              <p>
                {unreadCount
                  ? `${unreadCount} ${t('NOTIFICATIONS:Unread')}`
                  : t('NOTIFICATIONS:AllRead')}
              </p>
            </div>
          </div>
          <button
            type="button"
            className="pl4-notifications-dialog__close"
            onClick={props.onHide}
            aria-label={t('NOTIFICATIONS:CloseButton')}
            title={t('NOTIFICATIONS:CloseButton')}
          >
            <i className="fas fa-times" />
          </button>
        </Modal.Header>

        <Modal.Body className="pl4-notifications-dialog__body">
          {!notifications.length ? (
            <div className="pl4-notifications-dialog__empty">
              <span><i className="far fa-bell" /></span>
              <strong>{t('NOTIFICATIONS:EmptyTitle')}</strong>
              <p>{t('NOTIFICATIONS:EmptyDescription')}</p>
            </div>
          ) : (
            <div className="notifications-dialog-list custom-scrollbar">
              {notifications.map((notification: any, index: number) => (
                <Notification key={index}
                  project_id={notification.project_id}
                  notification={notification}
                  onClick={() => props.onHide()}
                />
              ))}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="pl4-notifications-dialog__footer">
          <button type="button" className="pl4-btn pl4-btn-secondary" onClick={props.onHide}>
            {t('NOTIFICATIONS:CloseButton')}
          </button>
        </Modal.Footer>
      </Modal>
  )
}

export default NotificationsDialog;
